import React from "react";
import { Alert, Button, Col, Row, Table } from "react-bootstrap";
import {
  EanNumber,
  ErrorList,
  Length,
  Money,
  OurDate,
  OurModal,
  Percentage,
  SuccessMessage,
  Weight,
} from "shared/components";
import OrderUnitImage from "shared/order-units/OrderUnitImage";
import OrderUnitProductInfo from "./OrderUnitProductInfo";
import OrderUnitProductCreator from "./OrderUnitProductCreator";

const OrderUnitProperties = (props) => {
  const { orderUnit } = props;

  return (
    <div id="order-unit-properties">
      <strong>Info</strong>
      <Table condensed bordered hover className="order-unit-properties-general">
        <tbody>
          <tr>
            <th>Platzierung</th>
            <td>{orderUnit.orderUnitType}</td>
          </tr>

          <tr>
            <th>Lieferantennummer</th>
            <td>{orderUnit.supplierArticleNumber}</td>
          </tr>

          <tr>
            <th>EAN</th>
            <td>
              <EanNumber value={orderUnit.ean} />
            </td>
          </tr>

          <tr>
            <th>EDM</th>
            <td>{orderUnit.edmNumber}</td>
          </tr>

          <tr>
            <th>Einkaufspreis</th>
            <td>
              <Money cents={orderUnit.netPriceCents} />
            </td>
          </tr>

          <tr>
            <th>Umsatzsteuer</th>
            <td>
              <Percentage value={orderUnit.vat} />
            </td>
          </tr>

          <tr>
            <th>Bestellbar ab</th>
            <td>
              <OurDate value={orderUnit.orderableFrom} />
            </td>
          </tr>

          <tr>
            <th>Bestellbar bis</th>
            <td>
              <OurDate value={orderUnit.orderableTo} />
            </td>
          </tr>

          <tr>
            <th>Restlaufzeit bei Wareneingang (in Tagen)</th>
            <td>{orderUnit.bestBeforeOnDeliveryInDays}</td>
          </tr>
        </tbody>
      </Table>

      <strong>Versand</strong>

      <Table
        condensed
        bordered
        hover
        className="order-unit-properties-shipping"
      >
        <tbody>
          <tr>
            <th>Bruttogewicht</th>
            <td>
              <Weight value={orderUnit.shippingUnitGrossWeight} />
            </td>
          </tr>

          <tr>
            <th>Nettogewicht</th>
            <td>
              <Weight value={orderUnit.shippingUnitNetWeight} />
            </td>
          </tr>

          <tr>
            <th>Breite</th>
            <td>
              <Length value={orderUnit.shippingUnitWidth} />
            </td>
          </tr>

          <tr>
            <th>Höhe</th>
            <td>
              <Length value={orderUnit.shippingUnitHeight} />
            </td>
          </tr>

          <tr>
            <th>Länge</th>
            <td>
              <Length value={orderUnit.shippingUnitLength} />
            </td>
          </tr>

          <tr>
            <th>Pfandart</th>
            <td>{orderUnit.shippingUnitDepositType.join(", ")}</td>
          </tr>

          <tr>
            <th>Pfandwert</th>
            <td>
              <Money cents={orderUnit.shippingUnitDepositValueCents} />
            </td>
          </tr>

          <tr>
            <th>Verpackungsart</th>
            <td>{orderUnit.shippingUnitPackaging}</td>
          </tr>
        </tbody>
      </Table>
    </div>
  );
};

const ApprovalModal = (props) => {
  return (
    <OurModal
      visible={props.isVisible}
      close={props.closeFn}
      modalTitle="Zur Prüfung an EDEKA StartHub schicken?"
    >
      <strong>Hinweis:</strong>
      Nach der Freigabe zur Prüfung kannst du diese Bestelleinheit nicht mehr
      bearbeiten.
      <br />
      <br />
      <div>
        <Button onClick={props.closeFn}>Abbrechen</Button>{" "}
        <Button onClick={props.submitFn}>Zur Prüfung Freigeben</Button>
      </div>
    </OurModal>
  );
};

class OrderUnitDetails extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      approvalModalVisible: false,
    };
  }

  isEditable() {
    return this.props.orderUnit.approvalState === "draft";
  }

  isPending() {
    return this.props.orderUnit.approvalState === "approval_requested";
  }

  openApprovalModal() {
    this.setState({
      approvalModalVisible: true,
    });
  }

  closeApprovalModal() {
    this.setState({
      approvalModalVisible: false,
    });
  }

  submitApprovalModal() {
    this.setState(
      {
        approvalModalVisible: false,
      },
      () => {
        this.props.requestOrderUnitApprovalFn(this.props.orderUnit.id);
      },
    );
  }

  render() {
    const { props } = this;
    const { orderUnit, allProducts } = props;

    if (!orderUnit) {
      return null;
    }

    return (
      <div className="order-unit-details">
        <ApprovalModal
          isVisible={this.state.approvalModalVisible}
          closeFn={this.closeApprovalModal.bind(this)}
          submitFn={this.submitApprovalModal.bind(this)}
        />
        <Row>
          <Col
            lg={10}
            lgOffset={1}
            md={12}
            className="order-unit-details-products"
          >
            <Row>
              <Col md={8}>
                <h3 className="order-unit-title">
                  Produkte in „{orderUnit.name}“
                </h3>
                <ErrorList errorMessages={props.submitErrorMessages} />

                {orderUnit.orderUnitsProducts &&
                  orderUnit.orderUnitsProducts.map(
                    (orderUnitProduct) => {
                      const product = orderUnit.products.find(prod => prod.id === orderUnitProduct.productId.toString())
                      return (
                        <OrderUnitProductInfo
                          key={`ouplist-${orderUnit.id}x${orderUnitProduct.productId}`}
                          orderUnit={orderUnit}
                          orderUnitProduct={orderUnitProduct}
                          product={product}
                          updateFn={props.updateOrderUnitProductFn}
                          removeFn={props.removeOrderUnitProductFn}
                          isSubmitting={props.isSubmitting}
                          isEditable={this.isEditable()}
                        />
                      );
                    },
                  )}
                {this.isEditable() && (
                  <OrderUnitProductCreator
                    orderUnit={props.orderUnit}
                    allProducts={allProducts}
                    addFn={props.addOrderUnitProductFn}
                    errorMessages={props.submitErrorMessages}
                    isSubmitting={props.isSubmitting}
                  />
                )}

                <SuccessMessage message={props.submitSuccessMessage} />
              </Col>

              <Col md={4} className="order-unit-details-attributes">
                <h4>Bestelleinheit: {orderUnit.name}</h4>

                <div className="order-unit-details-intro">
                  <Choose>
                    <When condition={this.isEditable()}>
                      <div>
                        <Button
                          className="btn btn-secondary"
                          href={`${orderUnit.id}/edit`}
                        >
                          Bearbeiten
                        </Button>{" "}
                        {orderUnit.orderUnitType && ( // as a simple check if an orderUnit is empty
                          <Button
                            className="btn btn-secondary"
                            onClick={this.openApprovalModal.bind(this)}
                          >
                            Freigeben
                          </Button>
                        )}
                      </div>
                    </When>

                    <When condition={this.isPending()}>
                      Diese Bestelloptionen wird derzeit von uns geprüft und
                      kann nicht bearbeitet werden. Bitte kontaktiere uns, wenn
                      Du Änderungen vornehmen möchtest.
                    </When>

                    <Otherwise>
                      Diese Bestelloptionen ist bereits freigeschaltet und kann
                      nicht bearbeitet werden. Bitte kontaktiere uns, wenn Du
                      Änderungen vornehmen möchtest.
                    </Otherwise>
                  </Choose>

                  <OrderUnitImage
                    orderUnit={orderUnit}
                    className="order-unit-details-preview-image"
                  />
                </div>

                {orderUnit.orderUnitType
                  ? ( // as a simple check if an orderUnit is empty
                    <OrderUnitProperties orderUnit={orderUnit} />
                  )
                  : (
                    <Alert>
                      Bitte lege die weiteren Details zu Deiner neuen
                      Bestelleinheit fest
                    </Alert>
                  )}
              </Col>
            </Row>
          </Col>
        </Row>
      </div>
    );
  }
}

export default OrderUnitDetails;
